<template>
  <div id="ge-sponsor">
    <strong>GE Aviation Fleet Support Team</strong>
    <div class="number"><strong>US: </strong>{{ geSponsor.US }}</div>
    <div class="number"><strong>International: </strong>{{ geSponsor.international }}</div>
    <div v-if="isPlaSfgtaForm" class="number"><strong>China and Asia: </strong>{{ geSponsor.chinaAsia }}</div>
    <div class="number">
      <strong>E-mail: </strong> <a :href="'mailto:' + geSponsor.email">aviation.fleetsupport@ge.com</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      geSponsor: {
        US: "+1 877 432 3272",
        international: "+1 513 552 3272",
        chinaAsia: "+86 400 820 6208",
        email: "aviation.fleetsupport@ge.com"
      },
      isPlaSfgtaForm: false
    };
  },
  created() {
    let isSFGTA = this.$route.path.includes("sfgta-agreement") || this.$route.path.includes("sfgtaSuccess");
    this.isPlaSfgtaForm = isSFGTA;
  }
};
</script>
<style lang="less" scoped>
#ge-sponsor {
  margin-top: 25px;
}
.number strong {
  color: @gray-dark;
}
</style>
